import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as Highcharts from 'highcharts';
import { DecimalPipe } from '@angular/common';
import { Point } from '../../../../models/pointWidget.model';
import { AnalyticsService } from '../../../../services/analytics/analytics.service';
import { CustomerCampaignService } from '../../../../services/customer/customer-campaign.service';
import { QFilterModel } from '../../../../models/qfilter.model';
import { IndicatorsService } from '../../../../services/indicators/indicators.service';

@Component({
  selector: 'app-customer-value-overview',
  templateUrl: 'customer-value-overview.component.html',
  styleUrls: ['./customer-value-overview.component.css']
})
export class CustomerValueOverviewComponent {

  customers_profilables: Point;
  customers_active: Point;
  customer_lose: Point;
  customer_new: Point;
  customer_percent_loyal_cards: Point;
  customer_percent_loyal_revenue: Point;
  show_results = false;

  optionRevenueNoOfCustomers = { };
  chartRevenueNoOfCustomers: any;
  revenueNoOfCustomersChartId: any;

  totals = [];

  constructor (
    private translate: TranslateService,
    public svcAnalytics: AnalyticsService,
    private svcCustomer: CustomerCampaignService,
    private numberPipe: DecimalPipe,
    private indicatorService: IndicatorsService
  ) {  }

  revenueNoOfCustomersChart(chartInstance: Highcharts.Chart) {
    this.chartRevenueNoOfCustomers = chartInstance;
    this.chartRevenueNoOfCustomers.reflow();
    this.revenueNoOfCustomersChartId = setInterval(() => {
      this.chartRevenueNoOfCustomers.reflow()
    }, 10);
  }

  showResult(filter: QFilterModel) {
    this.indicatorService.indicatorCalculation('Q055', filter).subscribe(res => {

      this.customers_profilables = res[0];
      this.customers_active = res[1];
      this.customer_lose = res[2];
      this.customer_new = res[3];
      this.customer_percent_loyal_cards = res[4];
      this.customer_percent_loyal_revenue = res[5];

      this.customers_profilables.title = 'customers.profilables';
      this.customers_active.title = 'customers.active';
      this.customer_lose.title = 'customers.lose';
      this.customer_new.title = 'customers.new';
      this.customer_percent_loyal_cards.title = 'customers.percent_loyal_cards';
      this.customer_percent_loyal_revenue.title = 'customers.percent_loyal_revenue';

      this.show_results = true
    });

    this.indicatorService.getChart('Q061', filter, false, '', true).subscribe( (response) => {

      const res = response['series'];
      res.splice(0, 1);

      console.log('res', res);
      const series: any = [];
      this.totals = res
        .map(g => [ g.serie[0], g.serie[1] ])
        .reduce((curr, prev) => [ curr[0] + prev[0], curr[1] + prev[1] ]);
      console.log('totals', this.totals);

      res.forEach(g => {
        if (g.titolo !== 'Categories') {
          series.push({
            name:  g.titolo,
            color:  g.serie[2],
            data: [
              (100 * g.serie[1] / this.totals[1]),
              (100 * g.serie[0] / this.totals[0])
            ]
          })
        }
      });
      console.log('series', series);
      const self = this;

      this.translate.get([
        'customers.client_number',
        'customers.revenues',
        'customerShoppingHabits.revenuesNumberOfCustomers'
      ]).subscribe(t => {
        this.optionRevenueNoOfCustomers = {
          credits: {
            enabled: false
          },
          showInLegend: true,
          chart: {
            type: 'column',
            zoomType: 'y',
            height: '660px'
          },
          title: {
            text: t['customerShoppingHabits.revenuesNumberOfCustomers'],
            align: 'center',
            style: {
              color: '#000000',
              fontSize: '18px'
            }
          },
          subtitle: {
            text: ''
          },
          yAxis: {
            max: 100,
            title: {
              text: ''
            }
          },
          xAxis: {
            categories: [t['customers.client_number'], t['customers.revenues']]
          },
          plotOptions: {
            column: {
              stacking: 'normal'
            }
          },
          tooltip: {
            formatter: function () {
              console.log(this);
              if (this.key === t['customers.revenues']) {
                return this.series.legendItem.textStr + ' - € ' + self.numberPipe.transform(self.totals[0] * this.y / 100.0, '0.0-2', 'it' ) + ' (' + this.y.toFixed(2) + ' %)';
              } else {
                return this.series.legendItem.textStr + ' - ' + self.numberPipe.transform(self.totals[1] * this.y / 100.0, '0.0-2', 'it') + ' (' + this.y.toFixed(2) + ' %)';
              }
            }
          },
          series: series,
          legend: {
            itemMarginBottom: 10,
            itemMarginTop: 10,
            align: 'left',
            layout: 'vertical',
            itemStyle: {
              fontSize: '15px'
            }
          }
        }
      })
    })
  }

  resetData() {
    this.show_results = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-value/customer-value-overview/customer-value-overview.component.ts